export default __webpack_public_path__ + "b937d5e01a6a18fd504ca019d975c1fb.png";